module.exports = __webpack_public_path__ + "img/sharp_t.unlinked.4db8678.png";